import dayjs from 'dayjs';
import dayJSUTC from './../../../../ext/dayjs/plugin/utc.js';

dayjs.extend(dayJSUTC);
const objToQuery = (obj, start = '?') => {
    return (start +
        Object.keys(obj)
            .reduce((array, key) => {
            if (obj[key] !== undefined) {
                array.push(`${key}=${encodeURIComponent(obj[key]).replace(/%2C/g, ',')}`);
            }
            return array;
        }, [])
            .join('&'));
};
const formatDateTime = (dateTime) => {
    return dayjs(dateTime).utc().format('YYYYMMDDTHHmmss') + 'Z';
};
const generateCalendarUrl = (calendarType, order, strings) => {
    const formattedTitle = strings.title
        .replace('{{firstServiceName}}', order.serviceName)
        .replace('{{venueName}}', order.venue.name);
    const formattedDescription = strings.description
        .replace('{{rescheduleHours}}', String(order.rescheduleHours))
        .replace('{{rescheduleUri}}', order.rescheduleUri)
        .replace('{{appDownloadUri}}', 'https://treatwell.onelink.me/32083905/c386fa74')
        .replace('{{cancellationUri}}', order.cancellationUri);
    const streetAddress = order.venue.location.address.addressLines.join(', ');
    const fullAddress = `${order.venue.name}, ${streetAddress} ${order.venue.location.address.postalCode}`;
    const formattedStartDateTime = formatDateTime(order.startDateTime);
    const formattedEndDateTime = formatDateTime(order.endDateTime);
    switch (calendarType) {
        case 'google': {
            const url = 'https://calendar.google.com/calendar/render';
            const query = {
                action: 'TEMPLATE',
                dates: `${formattedStartDateTime}/${formattedEndDateTime}`,
                location: fullAddress,
                text: formattedTitle,
                details: formattedDescription,
            };
            return `${url}${objToQuery(query)}`;
        }
        case 'yahoo': {
            const url = 'https://calendar.yahoo.com';
            const query = {
                v: '60',
                view: 'd',
                type: '20',
                dur: String(order.duration).padStart(4, '0'),
                title: formattedTitle,
                st: formattedStartDateTime,
                desc: formattedDescription,
                in_loc: fullAddress,
            };
            return `${url}${objToQuery(query)}`;
        }
        default: {
            const url = [
                'BEGIN:VCALENDAR',
                'VERSION:2.0',
                'BEGIN:VEVENT',
                'DTSTART:' + formattedStartDateTime,
                'DTEND:' + formattedEndDateTime,
                'SUMMARY:' + formattedTitle,
                'DESCRIPTION:' + formattedDescription.replace(/[\r\n]+/g, '\\n\\n'),
                'LOCATION:' + fullAddress,
                'END:VEVENT',
                'END:VCALENDAR',
            ].join('\n');
            return encodeURI(`data:text/calendar;charset=utf8,${url}`);
        }
    }
};

export { generateCalendarUrl };
//# sourceMappingURL=util.js.map
